import { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import './mobileShiftList.css';

function getWeekBounds() {
  const now = new Date();
  const day = now.getDay(); // 0 = Sunday
  const start = new Date(now);
  start.setDate(now.getDate() - day);
  start.setHours(0, 0, 0, 0);
  const end = new Date(start);
  end.setDate(start.getDate() + 7);
  return { start, end };
}

function formatShiftDate(datetimeStr) {
  return new Date(datetimeStr).toLocaleString('en-US', {
    weekday: 'short', month: 'short', day: 'numeric',
    hour: 'numeric', minute: '2-digit',
  });
}

export default function MobileShiftList({ eventList }) {
  const [expandedId, setExpandedId] = useState(null);

  const weekShifts = useMemo(() => {
    const { start, end } = getWeekBounds();
    return [...eventList]
      .filter(e => {
        const t = new Date(e.start).getTime();
        return t >= start.getTime() && t < end.getTime();
      })
      .sort((a, b) => new Date(a.start) - new Date(b.start));
  }, [eventList]);

  const toggle = (id) => setExpandedId(prev => prev === id ? null : id);

  return (
    <div className="mslContainer">
      <h2 className="mslTitle">My Shifts This Week</h2>

      {weekShifts.length === 0 ? (
        <p className="mslEmpty">No shifts scheduled this week.</p>
      ) : (
        <ul className="mslList">
          {weekShifts.map(shift => {
            const id = shift.docID;
            const isOpen = expandedId === id;
            const start = shift.editedStartTime || shift.start;
            const end   = shift.editedEndTime   || shift.end;

            return (
              <li key={id} className={`mslItem${isOpen ? ' mslItem--open' : ''}`}>
                <button
                  className="mslRow"
                  onClick={() => toggle(id)}
                  aria-expanded={isOpen}
                >
                  <div className="mslRowInfo">
                    <span className="mslClient">{shift.client}</span>
                    <span className="mslTime">{formatShiftDate(start)}</span>
                    <span className="mslTime mslTimeEnd">{formatShiftDate(end)}</span>
                  </div>
                  <span className={`mslChevron${isOpen ? ' mslChevron--open' : ''}`}>›</span>
                </button>

                {isOpen && (
                  <div className="mslActions">
                    <Link
                      to={`/client/${encodeURIComponent(shift.client)}`}
                      className="mslActionBtn mslActionBtn--history"
                    >
                      Care History
                    </Link>
                    <Link
                      to="/care-report"
                      state={{ shiftId: id }}
                      className="mslActionBtn mslActionBtn--report"
                    >
                      Care Report
                    </Link>
                  </div>
                )}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
